import jobDetails from './state/review-details-state';

export default function () {
  return {
    questions: [],
    answers: [],
    jobDetails: jobDetails(),
    id: null,
    reviewLimit: 4,
    jobDetailsPercent: 50,
    questionsPercent: 50,
    completionPercentage: 0,
    // showReviewIncentiveReviewOverview: false,
    // showReviewIncentiveCopyAtStart: true,
    // showReviewIncentivePopupAtSubmission: false,
    unfinishedReviews: [],
  };
}
